import React, { useState, useContext } from 'react';
import * as pluralize from 'pluralize';
import { UserInfo } from '../shared/models/user';
import WalkThroughModal from './WalkThroughModal';
import { ConfigContext } from '../shared/contexts/journeyConfig.context';

interface WalkthroughProps {
    setJobsPageFocus: Function,
    setDBPageFocus: Function,
    setAgentPageFocus: Function,
    handleNotNow: Function,
    showWalkthrough: boolean,
    userStartedTour: boolean,
    setCustomizePageFocus: Function,
    setShowProfileDropdown: Function,
    setShowEditProfile: Function,
    setProfileFocus: Function,
    setEditProfileFocus: Function,
    user: UserInfo,
    endWalkthrough: Function
}

function Walkthrough(props: WalkthroughProps) {
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [currentStepDotsLength, setCurrentStepDotsLength] = useState(1);
    const {
        setJobsPageFocus,
        setDBPageFocus,
        setAgentPageFocus,
        handleNotNow, 
        showWalkthrough,
        userStartedTour,
        setCustomizePageFocus,
        setShowProfileDropdown,
        setShowEditProfile,
        setProfileFocus,
        setEditProfileFocus,
        user,
        endWalkthrough,
    } = props;

    const welcomeText = `Welcome to Glympse Pro${!user?.username ? "" : ` ${user?.username}`}!`;
    const labels = useContext(ConfigContext);

    // reset focus
    const resetFocus = () => {
        setShowProfileDropdown(false);
        setShowEditProfile(false);
        setAgentPageFocus(false);
        setDBPageFocus(false);
        setJobsPageFocus(false);
        setCustomizePageFocus(false);
        setProfileFocus(false);
        setEditProfileFocus(false);
    }

    const STEPS = [
        {
            title: welcomeText,
            setFocus: setDBPageFocus,
            content: "Let's get started."
        },
        {
            title: "Dashboard",
            setFocus: setDBPageFocus,
            content: "Welcome to your dashboard; think of this as your one-stop shop for daily orders."
        },
        {
            setFocus: setJobsPageFocus,
            title: "Orders",
            content: "This is where you'll find all your created orders and where you can upload or create new orders."
        },
        {
            setFocus: setAgentPageFocus,
            title: `${pluralize(labels.agent)}`,
            content: `Here, you'll be able to see an overview of all of your ${pluralize(labels.agent)}.`
        },
        {
            setFocus: setCustomizePageFocus,
            title: "Customize",
            content: "Here, you'll be able to customize your site to showcase your company's brand."
        },
        {
            setFocus: setProfileFocus,
            toggleFunction: setShowProfileDropdown,
            title: "Your Account",
            content: "Click on your profile picture to either view your profile, contact us, or log out."
        },
        {
            setFocus: setEditProfileFocus,
            toggleFunction: setShowEditProfile,
            title: "Your Account",
            content: "Easily view and change your account details here."
        },
    ];

    
    const handleNextClick = (nextIndex) => {
        const fromDot = typeof nextIndex === 'number';
        if (!fromDot && currentStepIndex === 6) {
            endWalkthrough();
            return 
        }
        resetFocus();
        const nextStepIndex = fromDot ? nextIndex : (currentStepIndex + 1);
        const stepData = STEPS[nextStepIndex];
        const { setFocus, toggleFunction } = stepData;
        if ((showWalkthrough || userStartedTour) && setFocus) {
            setFocus(true);
        }
        if ((showWalkthrough || userStartedTour) && toggleFunction) {
            toggleFunction(true);
        }
        setCurrentStepIndex(nextStepIndex);
        if (currentStepDotsLength <  (nextStepIndex + 1)) {
            setCurrentStepDotsLength(nextStepIndex);
        }
    }

    return (
      <div>
        {STEPS.map((step, index) => (
            <WalkThroughModal
                key={`walkthrough-step-${index + 1}`}
                currentStepIndex={currentStepIndex}
                title={step.title}
                content={step.content}
                stepIndex={index}
                endWalkthrough={endWalkthrough}
                showWalkthrough={showWalkthrough}
                userStartedTour={userStartedTour}
                handleNotNow={handleNotNow}
                currentStepDotsLength={currentStepDotsLength}
                handleNext={handleNextClick}
            />
        ))}
      </div>
    );
}

export default Walkthrough;
